import { Id } from "PFTypes";
import { useCallback } from "react";

import { useBookingEditModeStoreActions, useWallPlannerModeState } from "../booking_edit_mode_store";

export const useWallPlannerMode = () => {
  const wallPlannerMode = useWallPlannerModeState();
  const { wallPlannerMode: wallPlannerModeActions } = useBookingEditModeStoreActions();

  const isBookingUpdatable = useCallback(
    (bookingId: Id) => wallPlannerMode.updatableBookingIds.includes(bookingId),
    [wallPlannerMode.updatableBookingIds]
  );

  return {
    loading: wallPlannerMode.isLoading,
    updatableBookingIds: wallPlannerMode.updatableBookingIds,
    isBookingUpdatable,
    setLoading: wallPlannerModeActions.setIsLoading,
    setFocusedInputId: wallPlannerModeActions.setFocusedInputId
  };
};
